/* =========================================================
WOMUSE · RING SIZES IN HER OWN SYSTEM (V20)
Works on top of the WOMUSE size picker; the picker and the theme are untouched.

- A UK · US · EU switch in the ring size panel. The UK opens on UK, Europe on
  EU, everywhere else on US. Her choice is remembered.
- The buttons are always the product's own US variants, shown in her system
  (matched by inside circumference from the WOMUSE Ring Size list). Choosing
  one selects that US variant exactly as before.
- Custom size: only when the product's "Made to Order" variant keeps selling
  when out of stock. Choosing one selects the Made to Order variant and adds
  the note "Custom ring size: US 5.25 · 50.0 mm (chosen as UK K)".
- Stock-only products: sold-out sizes are greyed out, no Custom size.
========================================================= */
(function () {
  'use strict';

  var KEY = 'wv20-ring-system';
  var EU = ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE','NO','CH','IS','LI'];
  function qa(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }
  function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function defaultSystem() {
    var saved = get(KEY);
    if (saved === 'UK' || saved === 'US' || saved === 'EU') return saved;
    var c = (window.Shopify && Shopify.country) || '';
    if (c === 'GB') return 'UK';
    if (EU.indexOf(c) > -1) return 'EU';
    return 'US';
  }
  var system = defaultSystem();

  function nearest(list, mm) {
    var best = null;
    list.forEach(function (s) {
      var d = Math.abs(s.mm - mm);
      if (!best || d < best.d - 1e-9 || (Math.abs(d - best.d) < 1e-9 && s.mm > best.s.mm)) best = { s: s, d: d };
    });
    return best ? best.s : null;
  }
  function mmText(mm) { var r = Math.round(mm * 100) / 100; return r % 1 === 0 ? r.toFixed(1) : String(r); }

  function setup(sel) {
    if (sel.dataset.wv20 === '1') return;
    if (!/ring/i.test(sel.getAttribute('data-womuse-option-name') || '')) return;
    var dataEl = sel.querySelector('[data-womuse-ring-size-data]');
    var varEl = sel.querySelector('[data-womuse-product-variant-data]');
    var opt = sel.closest('[data-product-option]');
    var native = opt && opt.querySelector('select[name^="options["]');
    var header = sel.querySelector('.womuse-size-selector__grid-header');
    var grid = sel.querySelector('.womuse-size-selector__grid');
    if (!dataEl || !varEl || !native || !header || !grid) return;
    var raw, variants;
    try { raw = JSON.parse(dataEl.textContent.trim()); variants = JSON.parse(varEl.textContent.trim()); } catch (e) { return; }
    sel.dataset.wv20 = '1';

    var bySys = { UK: [], US: [], EU: [] };
    raw.forEach(function (s) {
      var sys = String(s.system || '').toUpperCase();
      var mm = Number(s.circumference);
      if (bySys[sys] && isFinite(mm)) bySys[sys].push({ label: String(s.label).trim(), mm: mm, sort: Number(s.sort) || 0 });
    });
    Object.keys(bySys).forEach(function (k) { bySys[k].sort(function (a, b) { return a.mm - b.mm; }); });
    var usByLabel = {}; bySys.US.forEach(function (s) { usByLabel[s.label] = s; });
    function nearestUS(mm) { return nearest(bySys.US, mm); }

    var choices = qa('[data-womuse-size-choice]', grid);
    var stocked = choices.map(function (c) { return c.getAttribute('data-value'); });
    // Her system's label for each of our US variants
    function partner(sys, us) {
      var u = usByLabel[us]; if (!u) return null;
      if (sys === 'US') return u;
      var cand = bySys[sys].filter(function (s) { var n = nearestUS(s.mm); return n && n.label === us; });
      return cand.length ? nearest(cand, u.mm) : nearest(bySys[sys], u.mm);
    }
    function labelFor(us) { var p = partner(system, us); return p ? p.label : us; }

    // Remember the labels for the bag
    function saveForBag() {
      var map = {}; stocked.forEach(function (us) { map[us] = labelFor(us); });
      var mm = {}; bySys.US.forEach(function (s) { mm[s.label] = s.mm; });
      set('wv20-ring-map', JSON.stringify({ system: system, map: map, usMM: mm }));
    }

    // Which option is the ring size, and the other selects (colour)
    var form = sel.closest('form') || (sel.closest('[data-product-container]') || document).querySelector('form[action*="/cart/add"]');
    var container = sel.closest('[data-product-container]') || sel.closest('.product') || document;
    var womuseForm = container.querySelector('[data-womuse-product-form]') || form;
    var selects = qa('select[name^="options["]', container);
    var sizeIdx = selects.indexOf(native);
    function others() { return selects.map(function (s) { return s.value; }); }
    function variantFor(size) {
      var cur = others();
      return variants.filter(function (v) { return v.options.every(function (o, i) { return i === sizeIdx ? String(o) === String(size) : (cur[i] == null || String(o) === String(cur[i])); }); })[0];
    }
    var MTO = (native.querySelector('option[value="Made to Order"]') || Array.prototype.filter.call(native.options, function (o) { return /^made to order$/i.test(o.value.trim()); })[0] || {}).value;
    function customAllowed() {
      if (!MTO) return false;
      var v = variantFor(MTO);
      return !!(v && v.inventory_policy === 'continue');
    }

    // ---- switch in the header (replaces "US sizes"), size guide link kept
    var title = header.querySelector('.womuse-size-selector__grid-title');
    var sw = document.createElement('span');
    sw.className = 'wv20-sw'; sw.setAttribute('role', 'group'); sw.setAttribute('aria-label', 'Ring size system');
    sw.innerHTML = ['UK', 'US', 'EU'].map(function (s) { return '<button type="button" data-wv20-sys="' + s + '">' + s + '</button>'; }).join('');
    if (title) title.replaceWith(sw); else header.insertBefore(sw, header.firstChild);

    // ---- Custom size section, under the buttons
    var custom = document.createElement('div');
    custom.className = 'wv20-custom'; custom.setAttribute('data-wv20-custom', '');
    custom.innerHTML = '<button type="button" class="wv20-custom__head" aria-expanded="false" data-wv20-custom-toggle><span>Custom size <em>· made to your exact size</em></span><span class="wv20-custom__show">Show</span></button><div class="wv20-custom__body" hidden></div>';
    grid.insertAdjacentElement('afterend', custom);
    var body = custom.querySelector('.wv20-custom__body');

    var valueOut = sel.querySelector('[data-womuse-size-value]');
    var labelOut = sel.querySelector('[data-womuse-size-label]');
    var chosenCustom = null; // { label, sys, us, mm }

    function paint() {
      qa('[data-wv20-sys]', sw).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-wv20-sys') === system)); });
      choices.forEach(function (c) {
        var us = c.getAttribute('data-value');
        var span = c.querySelector('span:not(.womuse-size-selector__check)');
        if (!span) return;
        var lab = labelFor(us);
        var html = esc(lab) + (system !== 'US' ? '<small class="wv20-us">US ' + esc(us) + '</small>' : '');
        if (span.innerHTML !== html) span.innerHTML = html;
        var v = variantFor(us);
        var out = !!(v && !v.available);
        c.classList.toggle('wv20-soldout', out);
        c.disabled = out;
      });
      var allowed = customAllowed();
      custom.hidden = !allowed;
      if (allowed) paintCustom();
      paintValue();
      saveForBag();
    }

    function customList() {
      if (system === 'US') return null;
      var lo = (usByLabel[stocked[0]] || { mm: 46.8 }).mm - 1.2, hi = (usByLabel[stocked[stocked.length - 1]] || { mm: 62.2 }).mm + 1.2;
      var mapped = stocked.map(function (us) { return labelFor(us); });
      return bySys[system].filter(function (s) { return s.mm >= lo && s.mm <= hi && mapped.indexOf(s.label) < 0; });
    }
    function paintCustom() {
      var list = customList();
      var key = system + '|' + (chosenCustom ? chosenCustom.label + chosenCustom.sys : '');
      if (body.dataset.key === key) return;
      body.dataset.key = key;
      if (list) {
        body.innerHTML = '<div class="wv20-custom__grid">' + list.map(function (s) {
          var on = chosenCustom && chosenCustom.sys === system && chosenCustom.label === s.label;
          return '<button type="button" class="wv20-custom__size' + (on ? ' is-selected' : '') + '" data-wv20-custom-size="' + esc(s.label) + '">' + esc(s.label) + '</button>';
        }).join('') + '</div><p class="wv20-custom__note">We make it in your exact size.</p>';
      } else {
        body.innerHTML = '<div class="wv20-custom__row"><input type="text" inputmode="decimal" data-wv20-custom-input placeholder="For example 7.25" aria-label="Your exact ring size" value="' + (chosenCustom && chosenCustom.sys === 'US' ? esc(chosenCustom.label) : '') + '"><button type="button" data-wv20-custom-save>Save</button></div><p class="wv20-custom__err" data-wv20-custom-err hidden>Please choose a size in quarter steps, for example 7.25.</p><p class="wv20-custom__note">We make it in your exact size.</p>';
      }
    }

    function paintValue() {
      if (!valueOut || valueOut.hidden) return;
      var t = valueOut.textContent.trim();
      var want = null;
      if (chosenCustom && (/^made to order$/i.test(t) || t === valueOut.dataset.wv20)) want = chosenCustom.label + (chosenCustom.sys !== 'US' ? ' (' + chosenCustom.sys + ')' : '') + ' · Custom';
      else if (stocked.indexOf(t) > -1 || stocked.indexOf(valueOut.dataset.wv20us || '') > -1) {
        var us = stocked.indexOf(t) > -1 ? t : valueOut.dataset.wv20us;
        valueOut.dataset.wv20us = us;
        want = labelFor(us) + (system !== 'US' ? ' (' + system + ')' : '');
      }
      if (want && t !== want) { valueOut.dataset.wv20 = want; valueOut.textContent = want; }
    }
    if (valueOut) new MutationObserver(function () {
      var t = valueOut.textContent.trim();
      if (t !== valueOut.dataset.wv20) {
        if (stocked.indexOf(t) > -1) { valueOut.dataset.wv20us = t; chosenCustom = null; }
        paintValue();
      }
    }).observe(valueOut, { childList: true, characterData: true, subtree: true });

    function pickCustom(label, sys) {
      var src = bySys[sys].filter(function (s) { return s.label === label; })[0];
      if (!src || !MTO) return;
      var us = nearestUS(src.mm);
      var note = 'US ' + us.label + ' · ' + mmText(src.mm) + ' mm' + (sys !== 'US' ? ' (chosen as ' + sys + ' ' + label + ')' : '');
      chosenCustom = { label: label, sys: sys, us: us.label, mm: src.mm };
      native.value = MTO;
      native.dispatchEvent(new Event('change', { bubbles: true }));
      var f = form || womuseForm;
      if (f) {
        qa('[data-womuse-requested-ring-size]', document).forEach(function (x) { x.remove(); });
        var inp = document.createElement('input');
        inp.type = 'hidden'; inp.name = 'properties[Custom ring size]'; inp.value = note;
        inp.setAttribute('data-womuse-requested-ring-size', '');
        f.appendChild(inp);
      }
      if (womuseForm) womuseForm.dataset.womuseSizeSelected = 'true';
      sel.dataset.womuseSelected = 'true';
      if (labelOut) labelOut.textContent = sel.getAttribute('data-womuse-option-name') || 'Ring size';
      if (valueOut) { valueOut.hidden = false; valueOut.textContent = 'Made to Order'; }
      choices.forEach(function (c) { c.classList.remove('is-selected'); });
      body.dataset.key = ''; paintCustom(); paintValue();
      var close = sel.querySelector('[data-womuse-size-close]');
      if (close) close.click();
    }

    sel.addEventListener('click', function (e) {
      var s = e.target.closest('[data-wv20-sys]');
      if (s) { e.preventDefault(); system = s.getAttribute('data-wv20-sys'); set(KEY, system); body.dataset.key = ''; paint(); return; }
      var t = e.target.closest('[data-wv20-custom-toggle]');
      if (t) {
        e.preventDefault();
        var open = t.getAttribute('aria-expanded') !== 'true';
        t.setAttribute('aria-expanded', String(open)); body.hidden = !open;
        t.querySelector('.wv20-custom__show').textContent = open ? 'Hide' : 'Show';
        return;
      }
      var cs = e.target.closest('[data-wv20-custom-size]');
      if (cs) { e.preventDefault(); pickCustom(cs.getAttribute('data-wv20-custom-size'), system); return; }
      if (e.target.closest('[data-wv20-custom-save]')) {
        e.preventDefault();
        var inp = body.querySelector('[data-wv20-custom-input]');
        var v = inp ? inp.value.trim().replace(',', '.').replace(/^us\s*/i, '') : '';
        var n = parseFloat(v), lab = isFinite(n) ? String(n) : '';
        var err = body.querySelector('[data-wv20-custom-err]');
        if (!usByLabel[lab]) { if (err) err.hidden = false; if (inp) inp.focus(); return; }
        if (err) err.hidden = true;
        // A size we have as a variant is simply chosen as that size
        var std = choices.filter(function (c) { return c.getAttribute('data-value') === lab; })[0];
        if (std && !std.disabled) { std.click(); return; }
        pickCustom(lab, 'US');
      }
      // A standard size chosen: the custom choice is cleared (the picker removes its note)
      if (e.target.closest('[data-womuse-size-choice]')) { chosenCustom = null; body.dataset.key = ''; }
    });
    sel.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-wv20-custom-input]')) { e.preventDefault(); var b = body.querySelector('[data-wv20-custom-save]'); if (b) b.click(); }
    });
    selects.forEach(function (s, i) { if (i !== sizeIdx) s.addEventListener('change', function () { setTimeout(paint, 30); }); });

    paint();
  }

  function run() { qa('[data-womuse-size-selector]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true }); else run();
  setTimeout(run, 800);
})();
